import { v4 as uuidv4 } from 'uuid'

interface Props {
  [key: string]: any
}

export default function HomBinocularsIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  const uuid = uuidv4()
  return (
    <svg fill="none" viewBox="0 0 28 28" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ?? ''}
        d="M8.56537 10.8887L13.2299 8.81206L16.5991 16.38L11.9346 18.4566L8.56537 10.8887Z"
        fill="#5C21A9"
      />
      <path
        className={pathClassName ?? ''}
        d="M11.5994 5.522L11.1332 4.47493C10.5644 3.19735 11.1391 1.70052 12.4168 1.13166C12.885 0.923248 13.3932 0.866421 13.8771 0.949262C14.3608 1.03318 14.8208 1.25729 15.1922 1.61063L15.9693 2.35033"
        fill="#5C21A9"
      />
      <path
        className={pathClassName ?? ''}
        d="M11.7959 8.61725L15.7631 17.5284L21.8961 13.3339L26.1392 10.4316L18.9382 3.57787C18.2847 2.95597 17.4756 2.56157 16.6241 2.41421C15.7724 2.26764 14.8787 2.36773 14.0542 2.73477C13.9847 2.7657 13.9166 2.79798 13.8499 2.83202C11.7456 3.89727 10.8261 6.43885 11.7959 8.61725Z"
        fill="#5C21A9"
      />
      <path
        className={pathClassName ?? ''}
        d="M13.8499 2.83193L21.8961 13.3338L26.1391 10.4315L18.9382 3.57777C18.2846 2.95588 17.4755 2.56148 16.624 2.41412C15.7724 2.26754 14.8786 2.36764 14.0542 2.73468C13.9847 2.76561 13.9165 2.79789 13.8499 2.83193Z"
        fill="#727ED6"
      />
      <path
        className={pathClassName ?? ''}
        d="M27.4366 12.3308C28.8718 15.5545 27.4219 19.3312 24.1982 20.7664C20.9746 22.2015 17.198 20.7515 15.7629 17.5279C14.3277 14.3042 15.7774 10.5276 19.0011 9.09243C22.2247 7.65728 26.0015 9.10716 27.4366 12.3308Z"
        fill="#E4E4EF"
      />
      <path
        className={pathClassName ?? ''}
        d="M25.7271 13.092C26.7419 15.3714 25.7165 18.042 23.437 19.0568C21.1577 20.0715 18.4871 19.0464 17.4723 16.7669C16.4575 14.4875 17.4828 11.8169 19.7621 10.8022C22.0416 9.78739 24.7123 10.8125 25.7271 13.092Z"
        fill="#767ED6"
      />
      <path
        className={pathClassName ?? ''}
        d="M17.168 15.8127C18.402 17.4703 20.6603 18.1142 22.627 17.2386C24.5935 16.3632 25.6268 14.2539 25.2208 12.2276C23.9867 10.57 21.7287 9.92653 19.762 10.8021C17.7948 11.6779 16.762 13.7864 17.168 15.8127Z"
        fill={`url(#paint0_${uuid})`}
      />
      <path
        className={pathClassName ?? ''}
        d="M1.93105 8.60069L1.9012 7.52831C1.88735 7.01579 2.02861 6.52403 2.28993 6.10842C2.55223 5.69335 2.93452 5.35374 3.40266 5.14533C4.68025 4.57656 6.17727 5.15109 6.74605 6.42868L7.21219 7.47575"
        fill="#5C21A9"
      />
      <path
        className={pathClassName ?? ''}
        d="M9.38062 9.69308L13.3478 18.6042L6.12682 20.3549L1.13077 21.5658L0.856394 11.6283C0.831606 10.7265 1.07993 9.86136 1.54004 9.13008C2.00122 8.39904 2.67369 7.80185 3.49814 7.43481C3.56762 7.40388 3.63721 7.37484 3.7071 7.34809C5.90688 6.49716 8.41081 7.51468 9.38062 9.69308Z"
        fill="#727ED6"
      />
      <path
        className={pathClassName ?? ''}
        d="M3.7071 7.34809L6.12682 20.3549L1.13077 21.5658L0.856394 11.6283C0.831606 10.7265 1.07993 9.86136 1.54004 9.13008C2.00122 8.39904 2.67369 7.80185 3.49814 7.43481C3.56762 7.40388 3.63721 7.37484 3.7071 7.34809Z"
        fill="#5C21A9"
      />
      <path
        className={pathClassName ?? ''}
        d="M13.3478 18.6033C14.783 21.8269 13.3333 25.6036 10.1096 27.0387C6.88598 28.4739 3.10923 27.024 1.67408 23.8003C0.238932 20.5767 1.68882 16.7999 4.91246 15.3648C8.13611 13.9296 11.9127 15.3796 13.3478 18.6033Z"
        fill="#E4E4EF"
      />
      <path
        className={pathClassName ?? ''}
        d="M11.6384 19.3644C12.6532 21.6439 11.6278 24.3144 9.34854 25.3292C7.06906 26.344 4.3984 25.3189 3.38359 23.0394C2.36878 20.7599 3.39416 18.0894 5.67364 17.0746C7.95293 16.0598 10.6236 17.0849 11.6384 19.3644Z"
        fill="#767ED6"
      />
      <path
        className={pathClassName ?? ''}
        d="M11.1329 18.5001C11.5388 20.5264 10.5062 22.6353 8.53945 23.5109C6.57293 24.3864 4.31409 23.7428 3.08002 22.0852C2.67405 20.0589 3.7069 17.9503 5.67362 17.0747C7.64074 16.199 9.8988 16.8425 11.1329 18.5001Z"
        fill={`url(#paint1_${uuid})`}
      />
      <path
        className={pathClassName ?? ''}
        d="M5.90629 21.9168C6.26521 22.723 6.83051 23.3718 7.51339 23.8289C5.83118 24.1371 4.1035 23.4599 3.0796 22.0852C2.67382 20.0588 3.70667 17.9502 5.67319 17.0747C6.11317 16.8789 6.568 16.7589 7.02214 16.7099C5.59706 17.9827 5.08717 20.0769 5.90629 21.9168Z"
        fill="#6ABCFF"
      />
      <path
        className={pathClassName ?? ''}
        d="M19.9947 15.6443C20.3536 16.4505 20.9189 17.0993 21.6018 17.5565C19.9196 17.8646 18.1919 17.1874 17.168 15.8127C16.7622 13.7863 17.7951 11.6778 19.7616 10.8023C20.2015 10.6064 20.6562 10.4865 21.1105 10.4374C19.6854 11.7102 19.1755 13.8044 19.9947 15.6443Z"
        fill="#6ABCFF"
      />
      <defs className={pathClassName ?? ''}>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`paint0_${uuid}`}
          x1="17.1681"
          x2="25.2209"
          y1="15.8129"
          y2="12.2278"
        >
          <stop stopColor="#9AE6FF" />
          <stop offset="1" stopColor="#70B2FF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`paint1_${uuid}`}
          x1="3.08011"
          x2="11.133"
          y1="22.0854"
          y2="18.5003"
        >
          <stop stopColor="#9AE6FF" />
          <stop offset="1" stopColor="#70B2FF" />
        </linearGradient>
      </defs>
    </svg>
  )
}
